import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";

import * as componentTypes from "../../../../constants/componentTypes";
import * as settings from "../../../../constants/settings";
import * as navigationActions from "../../../../actions/navigationActions";
import * as formulaActions from "../../../../actions/formulaActions";
import * as conversionHelper from "../../../../helpers/conversionHelper";
import * as validationHelper from "../../../../helpers/validationHelper";
import * as modelHelper from "../../../../helpers/modelHelper";
import * as translationHelper from "../../../../helpers/translationHelper";

import imgConfirm from "../../../../resources/img/svgicons/confirm.svg";
import Modal from "../../../global/generic/Modal";
import Button from "../../../global/generic/Button";
import CancelButton from "../../../global/generic/CancelButton";
import Input from "../../../global/generic/Input";

class CustomPackageSettingsModal extends Component {
    /**
     * Rounding for decimal amount values
     */
    DECIMAL_PLACES = 5;

    /**
     * Density of base in product
     */
    baseDensity;

    /**
     * Colorant densities
     */
    colorantDensities;

    /**
     * Filling percentage of base in product
     */
    fillingPercentage;

    /**
     * Filling percentage of base in product in percent format
     */
    fillingPercentageFormatted;

    /**
     * Original sum of colorants amounts in mililiters
     */
    colorantsAmountMl;

    /**
     * Original sum of colorants amounts in grams
     */
    colorantsAmountG;

    /**
     * Base volume in mililiters
     */
    totalBaseAmountMl;

    /**
     * Base mass in grams
     */
    totalBaseAmountG;

    /**
     * Total volume in mililiters
     */
    totalAmountMl;

    /**
     * Total mass in grams
     */
    totalAmountG;

    /**
     * Colorant volumes in mililiters
     */
    colorantAmountsMl;

    /**
     * Colorant mass in grams
     */
    colorantAmountsG;

    constructor(props) {
        super(props);

        this.baseDensity = 1;
        this.colorantDensities = null;
        this.fillingPercentage = 1;
        this.fillingPercentageFormatted = "100";
        this.colorantsAmountMl = 0;
        this.colorantsAmountG = 0;
        this.totalBaseAmountMl = 0;
        this.totalBaseAmountG = 0;
        this.totalAmountMl = 0;
        this.totalAmountG = 0;
        this.colorantAmountsMl = {};
        this.colorantAmountsG = {};

        this.state = {
            metricSystemEnabled: false,
            metricSystem: "grav",
            unitList: [],
            baseUnit: settings.UNIT_KG,
            baseAmountInput: "0",
            baseAmount: 0,
            totalBaseAmountInput: "0",
            totalBaseAmount: 0,
            colorantsUnit: settings.UNIT_KG,
            colorantsAmountInput: "0",
            colorantsAmount: 0,
            totalUnit: settings.UNIT_KG,
            totalAmountInput: "0",
            totalAmount: 0,
            isValid: false,
            localData: false
        };
    }

    getRoundedAmount = (amount) => {
        return String(Math.round(amount * Math.pow(10, this.DECIMAL_PLACES)) / Math.pow(10, this.DECIMAL_PLACES));
    };

    isValid = () => {
        if (this.state.baseAmount < 0.00001) {
            return false;
        }

        if (this.state.totalBaseAmount < 0.00001) {
            return false;
        }

        if (this.state.colorantsAmount < 0.00001) {
            return false;
        }

        if (this.state.totalAmount < 0.00001) {
            return false;
        }

        return true;
    };

    componentDidMount = () => {
        let metricSystemEnabled = false;
        let unitListGrav = [];
        let unitListVol = [];

        if (
            this.props.params !== null &&
            this.props.params !== undefined &&
            Array.isArray(this.props.params.customPackageUnits)
        ) {
            for (let unit of this.props.unitList) {
                if (this.props.params.customPackageUnits.includes(unit.code)) {
                    if (unit.isGravimetric) {
                        unitListGrav.push(unit.code);
                    } else {
                        unitListVol.push(unit.code);
                    }
                }
            }

            metricSystemEnabled = unitListGrav.length > 0 && unitListVol.length > 0;
        }

        if (this.props.data !== null) {
            try {
                let baseUnit = null;
                let baseNominalAmount = null;

                let totalBaseVolume = null;
                let totalColorantVolume = null;
                let totalVolume = null;
                if (this.props.data.is_gravimetric) {
                    if (unitListGrav.includes(this.props.defaultUnitGrav)) {
                        baseUnit = this.props.defaultUnitGrav;
                        baseNominalAmount = conversionHelper.convertByUnits(
                            this.props.data.nominal_amount,
                            modelHelper.mapUnitCodeToConstant(this.props.data.unit.name),
                            this.props.defaultUnitGrav,
                            this.props.data.bip_density
                        );
                    } else {
                        baseUnit = modelHelper.mapUnitCodeToConstant(this.props.data.unit.name);
                        baseNominalAmount = this.props.data.nominal_amount;
                    }

                    totalBaseVolume = conversionHelper.convertByUnits(
                        this.props.data.base_mass_g,
                        settings.UNIT_G,
                        baseUnit
                    );
                    totalColorantVolume = conversionHelper.convertByUnits(
                        this.props.data.total_cnts_mass_g,
                        settings.UNIT_G,
                        baseUnit
                    );
                    totalVolume = conversionHelper.convertByUnits(
                        this.props.data.total_mass_g,
                        settings.UNIT_G,
                        baseUnit
                    );
                } else {
                    if (unitListVol.includes(this.props.defaultUnitVol)) {
                        baseUnit = this.props.defaultUnitVol;
                        baseNominalAmount = conversionHelper.convertByUnits(
                            this.props.data.nominal_amount,
                            modelHelper.mapUnitCodeToConstant(this.props.data.unit.name),
                            this.props.defaultUnitVol,
                            this.props.data.bip_density
                        );
                    } else {
                        baseUnit = modelHelper.mapUnitCodeToConstant(this.props.data.unit.name);
                        baseNominalAmount = this.props.data.nominal_amount;
                    }

                    totalBaseVolume = conversionHelper.convertByUnits(
                        this.props.data.base_volume_ml,
                        settings.UNIT_ML,
                        baseUnit
                    );
                    totalColorantVolume = conversionHelper.convertByUnits(
                        this.props.data.total_cnts_volume_ml,
                        settings.UNIT_ML,
                        baseUnit
                    );
                    totalVolume = conversionHelper.convertByUnits(
                        this.props.data.total_volume_ml,
                        settings.UNIT_ML,
                        baseUnit
                    );
                }

                this.baseDensity = this.props.data.bip_density;
                this.colorantDensities = this.props.data.cnt_densities;
                this.fillingPercentage = this.props.data.bip_fill_proc === 0 ? 1 : this.props.data.bip_fill_proc;
                this.fillingPercentageFormatted = this.getRoundedAmount(this.props.data.bip_fill_proc * 100);
                this.colorantsAmountMl = this.props.data.total_cnts_volume_ml;
                this.colorantsAmountG = this.props.data.total_cnts_mass_g;
                this.totalBaseAmountMl = this.props.data.base_volume_ml;
                this.totalBaseAmountG = this.props.data.base_mass_g;
                this.totalAmountMl = this.props.data.total_volume_ml;
                this.totalAmountG = this.props.data.total_mass_g;
                this.colorantAmountsMl = this.props.data.cnts_volumes_ml;
                this.colorantAmountsG = this.props.data.cnts_masses_g;

                this.setState({
                    metricSystemEnabled: metricSystemEnabled,
                    metricSystem: this.props.data.is_gravimetric ? "grav" : "vol",
                    unitList: this.props.data.is_gravimetric ? unitListGrav : unitListVol,
                    baseUnit: baseUnit,
                    baseAmountInput: this.getRoundedAmount(baseNominalAmount),
                    baseAmount: baseNominalAmount,
                    totalBaseAmountInput: this.getRoundedAmount(totalBaseVolume),
                    totalBaseAmount: totalBaseVolume,
                    colorantsUnit: baseUnit,
                    colorantsAmountInput: this.getRoundedAmount(totalColorantVolume),
                    colorantsAmount: totalColorantVolume,
                    totalUnit: baseUnit,
                    totalAmountInput: this.getRoundedAmount(totalVolume),
                    totalAmount: totalVolume,
                    isValid: true
                });
            } catch (e) {
                this.setState({isValid: false});
            }
        } else if (this.props.formula !== null && this.props.base !== null && this.props.package !== null) {
            this.colorantDensities = {};
            this.colorantsAmountMl = 0;
            this.colorantsAmountG = 0;
            this.colorantAmountsMl = {};
            this.colorantAmountsG = {};

            let baseUnit = null;
            let baseNominalAmount = null;

            for (let colorant of this.props.formula.realColorantList) {
                this.colorantsAmountMl += colorant.amount;
                this.colorantDensities[colorant.name] = colorant.density;
                this.colorantAmountsMl[colorant.name] = colorant.amount;
            }

            for (let colorant of this.props.formula.realColorantListG) {
                this.colorantsAmountG += colorant.amount;
                this.colorantAmountsG[colorant.name] = colorant.amount;
            }

            let colorantsTotal = null;
            if (this.props.package.package.isGravimetric) {
                if (unitListGrav.includes(this.props.defaultUnitGrav)) {
                    baseUnit = this.props.defaultUnitGrav;
                    baseNominalAmount = conversionHelper.convertByUnits(
                        this.props.package.package.nominalAmount,
                        this.props.package.package.unitCode,
                        this.props.defaultUnitGrav,
                        this.props.package.base.density
                    );
                } else {
                    baseUnit = this.props.package.package.unitCode;
                    baseNominalAmount = this.props.package.package.nominalAmount;
                }

                colorantsTotal = conversionHelper.convertByUnits(this.colorantsAmountG, settings.UNIT_G, baseUnit);
            } else {
                if (unitListVol.includes(this.props.defaultUnitVol)) {
                    baseUnit = this.props.defaultUnitVol;
                    baseNominalAmount = conversionHelper.convertByUnits(
                        this.props.package.package.nominalAmount,
                        this.props.package.package.unitCode,
                        this.props.defaultUnitVol,
                        this.props.package.base.density
                    );
                } else {
                    baseUnit = this.props.package.package.unitCode;
                    baseNominalAmount = this.props.package.package.nominalAmount;
                }

                colorantsTotal = conversionHelper.convertByUnits(this.colorantsAmountMl, settings.UNIT_ML, baseUnit);
            }

            this.baseDensity = this.props.package.base.density;
            this.fillingPercentage =
                this.props.base.baseInProductFillProc === 0 ? 1 : this.props.base.baseInProductFillProc;
            this.fillingPercentageFormatted = this.getRoundedAmount(this.props.base.baseInProductFillProc * 100);

            let totalBaseAmount = baseNominalAmount * this.fillingPercentage;

            if (this.props.package.package.isGravimetric) {
                this.totalBaseAmountMl = conversionHelper.convertByUnits(
                    totalBaseAmount,
                    this.props.package.package.unitCode,
                    settings.UNIT_ML,
                    this.props.package.base.density
                );
                this.totalBaseAmountG = conversionHelper.convertByUnits(
                    totalBaseAmount,
                    this.props.package.package.unitCode,
                    settings.UNIT_G
                );
            } else {
                this.totalBaseAmountMl = conversionHelper.convertByUnits(
                    totalBaseAmount,
                    this.props.package.package.unitCode,
                    settings.UNIT_ML
                );
                this.totalBaseAmountG = conversionHelper.convertByUnits(
                    totalBaseAmount,
                    this.props.package.package.unitCode,
                    settings.UNIT_G,
                    this.props.package.base.density
                );
            }

            this.totalAmountMl = this.colorantsAmountMl + this.totalBaseAmountMl;
            this.totalAmountG = this.colorantsAmountG + this.totalBaseAmountG;

            this.setState({
                metricSystemEnabled: metricSystemEnabled,
                metricSystem: this.props.package.package.isGravimetric ? "grav" : "vol",
                unitList: this.props.package.package.isGravimetric ? unitListGrav : unitListVol,
                baseUnit: baseUnit,
                baseAmountInput: this.getRoundedAmount(baseNominalAmount),
                baseAmount: baseNominalAmount,
                totalBaseAmountInput: this.getRoundedAmount(totalBaseAmount),
                totalBaseAmount: totalBaseAmount,
                colorantsUnit: baseUnit,
                colorantsAmountInput: this.getRoundedAmount(colorantsTotal),
                colorantsAmount: colorantsTotal,
                totalUnit: baseUnit,
                totalAmountInput: this.getRoundedAmount(totalBaseAmount + colorantsTotal),
                totalAmount: totalBaseAmount + colorantsTotal,
                isValid: true
            });
        }
        this.setState({localData: this.props.formula?.local});
    };

    calculateColorantsAmount = (totalBaseAmount) => {
        if (this.totalBaseAmountG === 0 || this.totalBaseAmountMl === 0) {
            return {
                colorantsAmount: 0,
                colorantsAmountForTotal: 0
            };
        }

        let unit = null;
        let colorantsAmount = 0;

        if (this.state.metricSystem === "grav") {
            unit = settings.UNIT_G;
            colorantsAmount =
                (conversionHelper.convertByUnits(totalBaseAmount, this.state.baseUnit, unit) / this.totalBaseAmountG) *
                this.colorantsAmountG;
        } else {
            unit = settings.UNIT_ML;
            colorantsAmount =
                (conversionHelper.convertByUnits(totalBaseAmount, this.state.baseUnit, unit) / this.totalBaseAmountMl) *
                this.colorantsAmountMl;
        }

        return {
            colorantsAmount: conversionHelper.convertByUnits(colorantsAmount, unit, this.state.colorantsUnit),
            colorantsAmountForTotal: conversionHelper.convertByUnits(colorantsAmount, unit, this.state.totalUnit)
        };
    };

    calculateColorantsAmountFromTotalAmount = (totalAmount) => {
        if (this.totalAmountG === 0 || this.totalAmountMl === 0) {
            return 0;
        }

        let unit = null;
        let colorantsAmount = 0;

        if (this.state.metricSystem === "grav") {
            unit = settings.UNIT_G;
            colorantsAmount =
                (conversionHelper.convertByUnits(totalAmount, this.state.totalUnit, unit) / this.totalAmountG) *
                this.colorantsAmountG;
        } else {
            unit = settings.UNIT_ML;
            colorantsAmount =
                (conversionHelper.convertByUnits(totalAmount, this.state.totalUnit, unit) / this.totalAmountMl) *
                this.colorantsAmountMl;
        }

        return conversionHelper.convertByUnits(colorantsAmount, unit, this.state.colorantsUnit);
    };

    calculateTotalBaseAmount = (colorantsAmount) => {
        if (this.colorantsAmountG === 0 || this.colorantsAmountMl === 0) {
            return {
                totalBaseAmount: 0,
                totalBaseAmountForTotal: 0
            };
        }

        let unit = null;
        let totalBaseAmount = 0;

        if (this.state.metricSystem === "grav") {
            unit = settings.UNIT_G;
            totalBaseAmount =
                (conversionHelper.convertByUnits(colorantsAmount, this.state.colorantsUnit, unit) /
                    this.colorantsAmountG) *
                this.totalBaseAmountG;
        } else {
            unit = settings.UNIT_ML;
            totalBaseAmount =
                (conversionHelper.convertByUnits(colorantsAmount, this.state.colorantsUnit, unit) /
                    this.colorantsAmountMl) *
                this.totalBaseAmountMl;
        }

        return {
            totalBaseAmount: conversionHelper.convertByUnits(totalBaseAmount, unit, this.state.baseUnit),
            totalBaseAmountForTotal: conversionHelper.convertByUnits(totalBaseAmount, unit, this.state.totalUnit)
        };
    };

    calculateTotalBaseAmountFromTotalAmount = (totalAmount) => {
        if (this.totalAmountG === 0 || this.totalAmountMl === 0) {
            return 0;
        }

        let unit = null;
        let totalBaseAmount = 0;

        if (this.state.metricSystem === "grav") {
            unit = settings.UNIT_G;
            totalBaseAmount =
                (conversionHelper.convertByUnits(totalAmount, this.state.totalUnit, unit) / this.totalAmountG) *
                this.totalBaseAmountG;
        } else {
            unit = settings.UNIT_ML;
            totalBaseAmount =
                (conversionHelper.convertByUnits(totalAmount, this.state.totalUnit, unit) / this.totalAmountMl) *
                this.totalBaseAmountMl;
        }

        return conversionHelper.convertByUnits(totalBaseAmount, unit, this.state.baseUnit);
    };

    /**
     * Converts colorant amounts across metric systems
     */
    convertColorantsAmount = (sourceMetric, unit) => {
        if (this.colorantsAmountG === 0 || this.colorantsAmountMl === 0) {
            return 0;
        }

        let currentUnit = sourceMetric === "grav" ? settings.UNIT_G : settings.UNIT_ML;
        let currentAmount = conversionHelper.convertByUnits(
            this.state.colorantsAmount,
            this.state.colorantsUnit,
            currentUnit
        );

        let result = 0;
        let amount = 0;
        for (let colorant of this.props.formula.colorantList) {
            if (sourceMetric === "grav") {
                amount = (currentAmount * this.colorantAmountsG[colorant.name]) / this.colorantsAmountG;
            } else {
                amount = (currentAmount * this.colorantAmountsMl[colorant.name]) / this.colorantsAmountMl;
            }

            result += conversionHelper.convertByUnits(amount, currentUnit, unit, this.colorantDensities[colorant.name]);
        }

        return result;
    };

    /**
     * Converts base amount within selected metric system.
     */
    processBaseUnit = (unit) => {
        let baseAmount = conversionHelper.convertByUnits(this.state.baseAmount, this.state.baseUnit, unit);
        let totalBaseAmount = this.fillingPercentage * baseAmount;

        return {
            baseUnit: unit,
            baseAmountInput: this.getRoundedAmount(baseAmount),
            baseAmount: baseAmount,
            totalBaseAmountInput: this.getRoundedAmount(totalBaseAmount),
            totalBaseAmount: totalBaseAmount
        };
    };

    processBaseAmount = (value) => {
        let newState = {
            baseAmountInput: "",
            baseAmount: 0,
            totalBaseAmountInput: "",
            totalBaseAmount: 0,
            colorantsAmountInput: "",
            colorantsAmount: 0,
            totalAmountInput: "",
            totalAmount: 0,
            isValid: true
        };

        newState.baseAmountInput = validationHelper.formatDecimal(value.trim());
        newState.baseAmount = Number(newState.baseAmountInput);

        newState.totalBaseAmount = this.fillingPercentage * newState.baseAmount;
        newState.totalBaseAmountInput = this.getRoundedAmount(newState.totalBaseAmount);

        let colorantsAmounts = this.calculateColorantsAmount(newState.totalBaseAmount);

        newState.colorantsAmount = colorantsAmounts.colorantsAmount;
        newState.colorantsAmountInput = this.getRoundedAmount(newState.colorantsAmount);

        newState.totalAmount =
            colorantsAmounts.colorantsAmountForTotal +
            conversionHelper.convertByUnits(newState.totalBaseAmount, this.state.baseUnit, this.state.totalUnit);
        newState.totalAmountInput = this.getRoundedAmount(newState.totalAmount);

        this.setState(newState);
    };

    /**
     * Sets base amount and calculates total amount within selected metric system.
     */
    processTotalBaseAmount = (value) => {
        let newState = {
            baseAmountInput: "",
            baseAmount: 0,
            totalBaseAmountInput: "",
            totalBaseAmount: 0,
            colorantsAmountInput: "",
            colorantsAmount: 0,
            totalAmountInput: "",
            totalAmount: 0,
            isValid: true
        };

        newState.totalBaseAmountInput = validationHelper.formatDecimal(value.trim());
        newState.totalBaseAmount = Number(newState.totalBaseAmountInput);

        newState.baseAmount = newState.totalBaseAmount === 0 ? 0 : newState.totalBaseAmount / this.fillingPercentage;
        newState.baseAmountInput = this.getRoundedAmount(newState.baseAmount);

        let colorantsAmounts = this.calculateColorantsAmount(newState.totalBaseAmount);

        newState.colorantsAmount = colorantsAmounts.colorantsAmount;
        newState.colorantsAmountInput = this.getRoundedAmount(newState.colorantsAmount);

        newState.totalAmount =
            colorantsAmounts.colorantsAmountForTotal +
            conversionHelper.convertByUnits(newState.totalBaseAmount, this.state.baseUnit, this.state.totalUnit);
        newState.totalAmountInput = this.getRoundedAmount(newState.totalAmount);

        this.setState(newState);
    };

    /**
     * Converts colorants amount within selected metric system.
     */
    processColorantsUnit = (unit) => {
        let colorantsAmount = conversionHelper.convertByUnits(
            this.state.colorantsAmount,
            this.state.colorantsUnit,
            unit
        );

        return {
            colorantsUnit: unit,
            colorantsAmountInput: this.getRoundedAmount(colorantsAmount),
            colorantsAmount: colorantsAmount
        };
    };

    /**
     * Sets colorants amount and calculates total amount within selected metric system.
     */
    processColorantsAmount = (value) => {
        let newState = {
            baseAmountInput: "",
            baseAmount: 0,
            totalBaseAmountInput: "",
            totalBaseAmount: 0,
            colorantsAmountInput: "",
            colorantsAmount: 0,
            totalAmountInput: "",
            totalAmount: 0,
            isValid: true
        };

        newState.colorantsAmountInput = validationHelper.formatDecimal(value.trim());
        newState.colorantsAmount = Number(newState.colorantsAmountInput);

        let totalBaseAmounts = this.calculateTotalBaseAmount(newState.colorantsAmount);

        newState.totalBaseAmount = totalBaseAmounts.totalBaseAmount;
        newState.totalBaseAmountInput = this.getRoundedAmount(newState.totalBaseAmount);

        newState.baseAmount = newState.totalBaseAmount === 0 ? 0 : newState.totalBaseAmount / this.fillingPercentage;
        newState.baseAmountInput = this.getRoundedAmount(newState.baseAmount);

        newState.totalAmount =
            totalBaseAmounts.totalBaseAmountForTotal +
            conversionHelper.convertByUnits(newState.colorantsAmount, this.state.colorantsUnit, this.state.totalUnit);
        newState.totalAmountInput = this.getRoundedAmount(newState.totalAmount);

        this.setState(newState);
    };

    /**
     * Converts total amount within selected metric system.
     */
    processTotalUnit = (unit) => {
        let totalAmount = conversionHelper.convertByUnits(this.state.totalAmount, this.state.totalUnit, unit);

        return {
            totalUnit: unit,
            totalAmountInput: this.getRoundedAmount(totalAmount),
            totalAmount: totalAmount
        };
    };

    /**
     * Sets total amount and calculates colorants and base amount within selected metric system.
     */
    processTotalAmount = (value) => {
        let newState = {
            baseAmountInput: "",
            baseAmount: 0,
            totalBaseAmountInput: "",
            totalBaseAmount: 0,
            colorantsAmountInput: "",
            colorantsAmount: 0,
            totalAmountInput: "",
            totalAmount: 0,
            isValid: true
        };

        newState.totalAmountInput = validationHelper.formatDecimal(value.trim());
        newState.totalAmount = Number(newState.totalAmountInput);

        newState.totalBaseAmount = this.calculateTotalBaseAmountFromTotalAmount(newState.totalAmount);
        newState.totalBaseAmountInput = this.getRoundedAmount(newState.totalBaseAmount);

        newState.baseAmount = newState.totalBaseAmount === 0 ? 0 : newState.totalBaseAmount / this.fillingPercentage;
        newState.baseAmountInput = this.getRoundedAmount(newState.baseAmount);

        newState.colorantsAmount = this.calculateColorantsAmountFromTotalAmount(newState.totalAmount);
        newState.colorantsAmountInput = this.getRoundedAmount(newState.colorantsAmount);

        this.setState(newState);
    };

    resetAllAmounts = () => {
        if (this.state.metricSystem === "grav") {
            this.processTotalAmount(
                String(conversionHelper.convertByUnits(this.totalAmountG, settings.UNIT_G, this.state.totalUnit))
            );
        } else {
            this.processTotalAmount(
                String(conversionHelper.convertByUnits(this.totalAmountMl, settings.UNIT_ML, this.state.totalUnit))
            );
        }
    };

    handleFocus = (event) => {
        event.target.select();
    };

    /**
     * Converts amounts across selected metric system.
     */
    handleMetricSystemChange = (event) => {
        let unitList = [];

        if (
            this.props.params !== null &&
            this.props.params !== undefined &&
            Array.isArray(this.props.params.customPackageUnits)
        ) {
            for (let unit of this.props.unitList) {
                if (this.props.params.customPackageUnits.includes(unit.code)) {
                    if (
                        (unit.isGravimetric && event.target.value === "grav") ||
                        (!unit.isGravimetric && event.target.value === "vol")
                    ) {
                        unitList.push(unit.code);
                    }
                }
            }
        }

        if (unitList.length > 0) {
            let unit = unitList[0];

            if (event.target.value === "grav" && unitList.includes(this.props.defaultUnitGrav)) {
                unit = this.props.defaultUnitGrav;
            } else if (event.target.value === "vol" && unitList.includes(this.props.defaultUnitVol)) {
                unit = this.props.defaultUnitVol;
            }

            let newState = {
                metricSystem: event.target.value,
                unitList: unitList,
                baseUnit: unit,
                baseAmountInput: "",
                baseAmount: 0,
                totalBaseAmountInput: "",
                totalBaseAmount: 0,
                colorantsUnit: unit,
                colorantsAmountInput: "",
                colorantsAmount: 0,
                totalUnit: unit,
                totalAmountInput: "",
                totalAmount: 0,
                isValid: true
            };

            newState.baseAmount = conversionHelper.convertByUnits(
                this.state.baseAmount,
                this.state.baseUnit,
                unit,
                this.baseDensity
            );
            newState.baseAmountInput = this.getRoundedAmount(newState.baseAmount);

            newState.totalBaseAmount = this.fillingPercentage * newState.baseAmount;
            newState.totalBaseAmountInput = this.getRoundedAmount(newState.totalBaseAmount);

            newState.colorantsAmount = this.convertColorantsAmount(this.state.metricSystem, unit);
            newState.colorantsAmountInput = this.getRoundedAmount(newState.colorantsAmount);

            newState.totalAmount = newState.totalBaseAmount + newState.colorantsAmount;
            newState.totalAmountInput = this.getRoundedAmount(newState.totalAmount);

            this.setState(newState);
        }
    };

    handleBaseUnitChange = (event) => {
        this.setState(this.processBaseUnit(event.target.value));
    };

    handleBaseAmountChange = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            if (event.target.value.trim().length !== 0) {
                this.processBaseAmount(event.target.value);
            } else {
                this.setState({baseAmountInput: "", isValid: false});
            }
        }
    };

    handleBaseAmountBlur = (event) => {
        if (event.target.value.trim().length === 0 || !this.isValid()) {
            this.resetAllAmounts();
        } else {
            this.setState({
                baseAmountInput: this.getRoundedAmount(this.state.baseAmount)
            });
        }
    };

    handleTotalBaseAmountChange = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            if (event.target.value.trim().length !== 0) {
                this.processTotalBaseAmount(event.target.value);
            } else {
                this.setState({totalBaseAmountInput: "", isValid: false});
            }
        }
    };

    handleTotalBaseAmountBlur = (event) => {
        if (event.target.value.trim().length === 0 || !this.isValid()) {
            this.resetAllAmounts();
        } else {
            this.setState({
                totalBaseAmountInput: this.getRoundedAmount(this.state.totalBaseAmount)
            });
        }
    };

    handleTotalAmountChange = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            if (event.target.value.trim().length !== 0) {
                this.processTotalAmount(event.target.value);
            } else {
                this.setState({totalAmountInput: "", isValid: false});
            }
        }
    };

    handleTotalAmountBlur = (event) => {
        if (event.target.value.trim().length === 0 || !this.isValid()) {
            this.resetAllAmounts();
        } else {
            this.setState({
                totalAmountInput: this.getRoundedAmount(this.state.totalAmount)
            });
        }
    };

    handleTotalUnitChange = (event) => {
        this.setState(this.processTotalUnit(event.target.value));
    };

    handleColorantsAmountChange = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            if (event.target.value.trim().length !== 0) {
                this.processColorantsAmount(event.target.value);
            } else {
                this.setState({colorantsAmountInput: "", isValid: false});
            }
        }
    };

    handleColorantsAmountBlur = (event) => {
        if (event.target.value.trim().length === 0 || !this.isValid()) {
            this.resetAllAmounts();
        } else {
            this.setState({
                colorantsAmountInput: this.getRoundedAmount(this.state.colorantsAmount)
            });
        }
    };

    handleColorantsUnitChange = (event) => {
        this.setState(this.processColorantsUnit(event.target.value));
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
    };

    handleConfirmClick = () => {
        let modified = false;

        let colorantsAmount = conversionHelper.convertByUnits(
            this.state.colorantsAmount,
            this.state.colorantsUnit,
            this.state.metricSystem === "grav" ? settings.UNIT_G : settings.UNIT_ML
        );

        if (
            (this.state.metricSystem === "grav" && colorantsAmount !== this.colorantsAmountG) ||
            (this.state.metricSystem === "vol" && colorantsAmount !== this.colorantsAmountMl)
        ) {
            modified = true;
        }

        let colorantList = null;

        if (modified) {
            colorantList = [];

            if (this.state.metricSystem === "grav") {
                for (let colorant of this.props.formula.realColorantListG) {
                    if (this.colorantsAmountG !== 0) {
                        colorantList.push(
                            colorant.updateAmount(
                                (colorantsAmount * this.colorantAmountsG[colorant.name]) / this.colorantsAmountG
                            )
                        );
                    } else {
                        colorantList.push(colorant.updateAmount(0));
                    }
                }
            } else {
                for (let colorant of this.props.formula.realColorantList) {
                    if (this.colorantsAmountMl !== 0) {
                        colorantList.push(
                            colorant.updateAmount(
                                (colorantsAmount * this.colorantAmountsMl[colorant.name]) / this.colorantsAmountMl
                            )
                        );
                    } else {
                        colorantList.push(colorant.updateAmount(0));
                    }
                }
            }
        }

        this.props.dispatchEditColorantsAction(
            this.props.tabId,
            colorantList,
            this.state.metricSystem === "grav" ? settings.UNIT_G : settings.UNIT_ML,
            modified,
            1,
            this.props.shotsCoef,
            this.props.shotsName,
            modelHelper.buildCustomPackage(
                0,
                this.state.baseAmount,
                this.props.unitList.find((unit) => unit.code === this.state.baseUnit),
                this.props.package,
                this.props.base
            )
        );
        this.props.dispatchCloseModalAction();
    };

    getUnitList = () => {
        let unitList = [];

        for (let unit of this.state.unitList) {
            unitList.push(
                <option key={unit} value={unit}>
                    {translationHelper.getUnitTranslation(unit)}
                </option>
            );
        }

        return unitList;
    };

    getColorantList = () => {
        let colorantList = [];

        if (this.state.metricSystem === "grav") {
            for (let colorant of this.props.formula.realColorantListG) {
                colorantList.push(
                    <div className="col-12 flex padding-left-10 padding-right-10 padding-bottom-5" key={colorant.id}>
                        <div className="col-6">{colorant.displayName}</div>
                        <div className="col-6 text-right">
                            {colorant.formatAmount()} {colorant.amountType}
                        </div>
                    </div>
                );
            }

            return colorantList;
        }

        for (let colorant of this.props.formula.realColorantList) {
            colorantList.push(
                <div className="col-12 flex padding-left-10 padding-right-10 padding-bottom-5" key={colorant.id}>
                    <div className="col-6">{colorant.displayName}</div>
                    <div className="col-6 text-right">
                        {colorant.formatAmount()} {colorant.amountType}
                    </div>
                </div>
            );
        }

        return colorantList;
    };

    getConfirmButton = () => {
        if (this.state.isValid) {
            return (
                <Button
                    onClick={this.handleConfirmClick}
                    svgBefore={imgConfirm}
                    label={<Translate value="general.confirm" />}
                />
            );
        }

        return <Button svgBefore={imgConfirm} label={<Translate value="general.confirm" />} disabled={true} />;
    };

    getSubheader = () => {
        if (!this.state.metricSystemEnabled) {
            if (this.state.metricSystem === "grav") {
                return (
                    <div className="col-12 text-right">
                        <Translate value="general.package" />:
                        <span className="margin-left-10">
                            <Translate value="general.gravimetric" />
                        </span>
                    </div>
                );
            }
            return (
                <div className="col-12 text-right">
                    <Translate value="general.package" />:
                    <span className="margin-left-10">
                        <Translate value="general.volumetric" />
                    </span>
                </div>
            );
        }
        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="col-12 text-right">
                    <Translate value="general.package" />:
                    <select
                        className="primary-select col-4 margin-left-5 min-width-65"
                        value={this.state.metricSystem}
                        onChange={this.handleMetricSystemChange}
                    >
                        <option value="grav">{translate("general.gravimetric")}</option>
                        <option value="vol">{translate("general.volumetric")}</option>
                    </select>
                </div>
            </React.Fragment>,
            "flex-row-gap-10px flex-wrap slim-scroll font-1_5vh"
        );
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="col-12 flex min-width-400">
                    <div className="col-6 border-right">
                        <div className="text-center font-size-1_75em color-primary padding-bottom-10">
                            <Translate value="general.colorants" />
                        </div>
                        {this.getColorantList()}
                        <div className="col-12 padding-left-10 padding-right-10 padding-bottom-5 flex flex-align-center-vertical">
                            <div className="padding-right-5">
                                <Translate value={"general.totalColorantAmount"} />:
                            </div>
                            <Input
                                className="col-3 primary-input margin-right-5 margin-left-5"
                                type="text"
                                value={this.state.colorantsAmountInput}
                                onFocus={this.handleFocus}
                                onChange={this.handleColorantsAmountChange}
                                onBlur={this.handleColorantsAmountBlur}
                            />
                            <select
                                className="primary-select"
                                value={this.state.colorantsUnit}
                                onChange={this.handleColorantsUnitChange}
                            >
                                {this.getUnitList()}
                            </select>
                        </div>
                    </div>
                    <div className="col-6 padding-left-10">
                        <div className="text-center font-size-1_75em color-primary padding-bottom-10">
                            <Translate value="general.base" />
                        </div>
                        <div className="flex flex-align-center-vertical padding-bottom-5">
                            <div className="col-5 padding-right-5">
                                <Translate value="general.nominalAmount" />:
                            </div>
                            <Input
                                className="col-3 primary-input margin-right-5"
                                type="text"
                                value={this.state.baseAmountInput}
                                onFocus={this.handleFocus}
                                onChange={this.handleBaseAmountChange}
                                onBlur={this.handleBaseAmountBlur}
                            />
                            <select
                                className="primary-select"
                                value={this.state.baseUnit}
                                onChange={this.handleBaseUnitChange}
                            >
                                {this.getUnitList()}
                            </select>
                        </div>
                        <div className="flex flex-align-center-vertical padding-bottom-5">
                            <div className="col-5 padding-right-5">
                                <Translate value="general.filling" />
                            </div>
                            <Input
                                className="col-3 disabled-input margin-right-5"
                                type="text"
                                value={this.fillingPercentageFormatted}
                                readOnly
                                disabled={true}
                            />
                            <span>%</span>
                        </div>
                        <div className="flex flex-align-center-vertical padding-bottom-5">
                            <div className="col-5 padding-right-5">
                                <Translate value="general.totalBaseAmount" />
                            </div>
                            <Input
                                className="col-3 primary-input margin-right-5"
                                type="text"
                                value={this.state.totalBaseAmountInput}
                                onFocus={this.handleFocus}
                                onChange={this.handleTotalBaseAmountChange}
                                onBlur={this.handleTotalBaseAmountBlur}
                            />
                            {translationHelper.getUnitTranslation(this.state.baseUnit)}
                        </div>
                    </div>
                </div>
                <div className="modal-footer col-12 flex flex-align-center font-1_5vh horizontal-separator-arrow-down">
                    <div className="padding-right-5">
                        <Translate value="general.totalAmount" />:
                    </div>
                    <Input
                        className="primary-input margin-right-5 col-2 min-width-65"
                        type="text"
                        value={this.state.totalAmountInput}
                        onFocus={this.handleFocus}
                        onChange={this.handleTotalAmountChange}
                        onBlur={this.handleTotalAmountBlur}
                    />
                    <select
                        className="primary-select"
                        value={this.state.totalUnit}
                        onChange={this.handleTotalUnitChange}
                    >
                        {this.getUnitList()}
                    </select>
                </div>
            </React.Fragment>,
            "flex-row-gap-10px flex-wrap slim-scroll font-1_5vh"
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                {this.getConfirmButton()}
                <CancelButton onClick={this.handleCloseModalClick} />
            </React.Fragment>,
            "col-12 text-right "
        );
    };

    render() {
        if (this.props.formula === null || this.props.package === null || this.props.base === null) {
            return (
                <Modal
                    modalId={this.props.id}
                    onClose={this.handleCloseModalClick}
                    header={modelHelper.buildModalSection(<Translate value="general.customPackageSettings" />)}
                    content={modelHelper.buildModalSection()}
                    footer={this.getFooter()}
                />
            );
        }
        return (
            <Modal
                className={this.state.localData ? "custom-formula" : null}
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="general.customPackageSettings" />)}
                subHeader={this.getSubheader()}
                content={this.getContent()}
                footer={this.getFooter()}
            />
        );
    }
}

const mapStoreToProps = (store, ownProps) => {
    if (store.formula[ownProps.tabId] === undefined || store.formula[ownProps.tabId].active === false) {
        return {
            base: null,
            package: null,
            formula: null,
            data: null,
            unitList: store.global.unitList,
            defaultUnitGrav: store.settings.customCanSettingsUnitGrav,
            defaultUnitVol: store.settings.customCanSettingsUnitVol,
            shotsCoef: store.settings.shotsCoef,
            shotsName: store.settings.shotsName
        };
    }

    return {
        base: store.formula[ownProps.tabId].base,
        package: store.formula[ownProps.tabId].package,
        formula: store.formula[ownProps.tabId].formula,
        data: store.formula[ownProps.tabId].customPackageAmounts,
        unitList: store.global.unitList,
        defaultUnitGrav: store.settings.customCanSettingsUnitGrav,
        defaultUnitVol: store.settings.customCanSettingsUnitVol,
        shotsCoef: store.settings.shotsCoef,
        shotsName: store.settings.shotsName
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.CUSTOM_PACKAGE_SETTINGS_MODAL));
        },
        dispatchEditColorantsAction: (
            tabId,
            colorantList,
            unit,
            modified,
            scaling,
            shotsCoef,
            shotsName,
            customPackage
        ) => {
            dispatch(
                formulaActions.editColorants(
                    tabId,
                    colorantList,
                    unit,
                    modified,
                    scaling,
                    shotsCoef,
                    shotsName,
                    customPackage
                )
            );
        }
    };
};

export default CustomPackageSettingsModal = connect(mapStoreToProps, mapDispatchToProps)(CustomPackageSettingsModal);
